import { useModal } from '@starsoft/common/hooks';
import TransactionsLayout from '../../Layout';
import TransactionModalsDepositContentLayout from './Layout';
import TransactionModalsDepositContent from './Content';
import { CommonModalsKey } from '@starsoft/common/enums';
import { TransactionModalDepositProps } from './props';

/**
 * TransactionModalDeposit Component
 * This component is responsible for rendering the deposit modal with its content and layout.
 * It utilizes the useModal hook to manage modal state and callbacks.
 *
 * @param {TransactionModalDepositProps} props - The properties for the component.
 * @param {React.ReactNode} props.additionalContent - Additional content to be rendered inside the deposit modal.
 *
 * @returns {JSX.Element} The rendered deposit modal component.
 *
 * @example
 * // Usage example:
 * <TransactionModalDeposit additionalContent={<div>Extra Content</div>} />
 */
export function TransactionModalDeposit({
  additionalContent,
  originId,
  version,
}: TransactionModalDepositProps) {
  // Retrieve modal callbacks for the 'Deposit' modal
  const modalCallbacks = useModal(CommonModalsKey.Deposit);

  // Render the TransactionsLayout with the deposit content and layout
  return (
    <TransactionsLayout modalCallbacks={modalCallbacks} version={version}>
      <TransactionModalsDepositContentLayout
        originId={originId}
        version={version}
      >
        <TransactionModalsDepositContent
          additionalContent={additionalContent}
        />
      </TransactionModalsDepositContentLayout>
    </TransactionsLayout>
  );
}
